/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-thin-right': {
    width: 18,
    height: 32,
    viewBox: '0 0 18 32',
    data: '<path pid="0" d="M1.094 31.969a1.087 1.087 0 00.75-.313l15-15.031c.208-.208.312-.458.312-.75s-.104-.542-.312-.75L2.062.312A1.041 1.041 0 001.297 0C.995 0 .74.104.53.313a1.041 1.041 0 00-.312.765c0 .302.104.557.312.766l14.063 14.031L.313 30.156a1.023 1.023 0 00-.313.75c0 .292.104.542.313.75.104.104.223.183.359.235.135.052.276.078.422.078z" _fill="#000" fill-rule="nonzero"/>'
  }
})
